import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSmileBeam } from 'react-icons/fa';
import Lottie from 'lottie-react';
import './style/Onboarding.css';

import CreateEventImg from '../assets/img/Onboarding/createevent.png';
import EventsListImg from '../assets/img/Onboarding/listevent.png';
import EventHomeImg from '../assets/img/Onboarding/homeevent.png';
import MenuImg from '../assets/img/Onboarding/Settings.png';

import { useTranslation } from 'react-i18next';
import StartNowEN from '../assets/animations/StartNow_en.json';
import StartNowFR from '../assets/animations/StartNow_fr.json';
import NextEN from '../assets/animations/Next_en.json';
import SuivantFR from '../assets/animations/Suivant_fr.json';

const Onboarding = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [animate, setAnimate] = useState(false);
  const [displayedStep, setDisplayedStep] = useState(0);

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const currentLang = i18n.language;

  // Choisir la bonne animation selon l'étape et la langue
  const getButtonAnimation = (isLastStep) => {
    if (isLastStep) {
      return currentLang === 'fr' ? StartNowFR : StartNowEN;
    } else {
      return currentLang === 'fr' ? SuivantFR : NextEN;
    }
  };

  const stepsData = [
    {
      icon: <FaSmileBeam className="onboarding-icon" />,
      title: t('OnBoarding.step0.title'),
      text: t('OnBoarding.step0.text'),
    },
    {
      title: t('OnBoarding.step1.title'),
      text: t('OnBoarding.step1.text'),
      image: CreateEventImg
    },
    {
      title: t('OnBoarding.step2.title'),
      text: t('OnBoarding.step2.text'),
      image: EventsListImg
    },
    {
      title: t('OnBoarding.step3.title'),
      text: t('OnBoarding.step3.text'),
      image: EventHomeImg
    },
    {
      title: t('OnBoarding.step4.title'),
      text: t('OnBoarding.step4.text'),
      image: MenuImg
    },
    {
      title: t('OnBoarding.step5.title'),
      text: t('OnBoarding.step5.text'),
      action: () => navigate('/create-event'),
      lottie: true
    }
  ];

  const handleNext = () => {
    const current = stepsData[step];
    if (current.action) {
      current.action();
    } else {
      const nextStep = step + 1;
      setDisplayedStep(nextStep);
      setAnimate(true);
      setTimeout(() => {
        setStep(nextStep);
        setAnimate(false);
      }, 300);
    }
  };

  const currentStep = stepsData[animate ? displayedStep : step];
  const isLastStep = (step === stepsData.length - 1);
  const buttonAnimation = getButtonAnimation(isLastStep);

  return (
    <div className="onboarding-wrapper">
      <div className="onboarding-steps">
        {stepsData.map((_, index) => (
          <div
            key={index}
            className={`onboarding-step ${step === index ? 'active' : ''}`}
          >
            {index + 1}
          </div>
        ))}
      </div>

      <div className={`onboarding-box ${animate ? 'slide-animation' : ''}`}>
        {currentStep.icon && (
          <div className="onboarding-header">
            {currentStep.icon}
            <h2>{currentStep.title}</h2>
          </div>
        )}
        {!currentStep.icon && (
          <h2 style={{ marginBottom: '12px' }}>{currentStep.title}</h2>
        )}
        <p className="onboarding-subtext">{currentStep.text}</p>

        {currentStep.image && (
          <img
            src={currentStep.image}
            alt={currentStep.title}
            className={`onboarding-image ${currentStep.title === 'Menu' ? 'onboarding-image-menu' : ''}`}
          />
        )}

        <div style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }} onClick={handleNext}>
          <Lottie
            animationData={buttonAnimation}
            loop
            style={{ width: 220, height: 50 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
